import { BenefitsDependentEnrollment, BenefitsEnrollment } from "@oysterhr/schema"

export function getEmployerContributionPercentage(
  enrollment?: BenefitsDependentEnrollment | BenefitsEnrollment,
) {
  switch (enrollment?.__typename) {
    case "BenefitsEnrollment":
      return enrollment.employerContribution ?? undefined
    case "BenefitsDependentEnrollment":
      return enrollment.recommendedEmployerContribution ?? undefined
    default:
      return undefined
  }
}
